module.exports = __webpack_public_path__ + "static/media/digital-marketing-introduce-3.e9eca6b5.png";